module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/points/point_04-04afdc327f83b79c6c2ff04ee819e49e.svg";